import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';

import { VariableScope } from '../../FlowDesigner/Models/VariableScopes/VariableScope';
import { IComponentModel } from '../Models/IComponentModel';
import { ComponentPath } from '../Utils/ComponentTreeUtils';
import {
	ResolvedVirtualCollectionSelection,
	getCollectionItems,
	getPathAfterVirtualCollectionItemDelete,
	removeComponentCollectionItem,
	toVirtualCollectionItem,
	toVirtualComponent,
	updateComponentCollectionItem,
} from '../Utils/VirtualComponentCollectionUtils';
import { ComponentProperties } from './ComponentProperties';

type VirtualCollectionItemPropertiesProps = {
	selection: ResolvedVirtualCollectionSelection;
	item: Record<string, unknown>;
	variableScope?: VariableScope;
	onOwnerComponentChanged: (updatedComponent: IComponentModel) => void;
	onSelectedComponentPathChanged?: (path: ComponentPath | null) => void;
	mapSelectionPath?: (path: ComponentPath) => ComponentPath;
};

export function VirtualCollectionItemProperties({
	selection,
	item,
	variableScope,
	onOwnerComponentChanged,
	onSelectedComponentPathChanged,
	mapSelectionPath = (path) => path,
}: VirtualCollectionItemPropertiesProps) {
	const handleDeleteVirtualItem = () => {
		const updatedComponent = removeComponentCollectionItem(selection.component, selection.parameter, selection.itemIndex);
		const remainingItemCount = getCollectionItems(updatedComponent, selection.parameter).length;

		onOwnerComponentChanged(updatedComponent);
		onSelectedComponentPathChanged?.(mapSelectionPath(getPathAfterVirtualCollectionItemDelete(selection, remainingItemCount)));
	};

	return (
		<Stack spacing={2}>
			<Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
				<Box sx={{ flex: 1 }} />
				<Tooltip title="Delete component">
					<span>
						<IconButton size="small" onClick={handleDeleteVirtualItem} color="error">
							<DeleteIcon fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			</Box>
			<ComponentProperties
				component={toVirtualComponent(item, selection.itemIndex, selection.virtualMetadata.name)}
				metadata={selection.virtualMetadata}
				variableScope={variableScope}
				onComponentChanged={(updated) => {
					onOwnerComponentChanged(
						updateComponentCollectionItem(selection.component, selection.parameter, selection.itemIndex, toVirtualCollectionItem(updated)),
					);
				}}
			/>
		</Stack>
	);
}
